import { Quaternion as i, Vector3 as o } from "three";
import { SignedAngle as m } from "./index32.js";
import { Vectors as p } from "./index36.js";
const n = new i(), e = new o(1, 0, 0);
function l(r, t = new o(0, 1, 0)) {
  return e.set(1, 0, 0), n.setFromEuler(r), e.applyQuaternion(n), m(e, p.Right, t);
}
export {
  l as EulerToSignedAngle
};
//# sourceMappingURL=index9.js.map
